<!-- 云稼民宿 -->
<template>
  <div>
    <el-carousel :height="computeHeight">
      <el-carousel-item v-for="(item, index) in sliders" :key="index">
        <img :src="item.img" class="banner" />
      </el-carousel-item>
    </el-carousel>
    <!-- 适用商家 -->
    <div class="homestay_apply_bg">
      <div class="homestay_apply_title">适用商家</div>
      <div class="homestay_apply_center">
        <el-row :gutter="40">
          <el-col
            :span="6"
            v-for="(item, index) in homestay_apply_item"
            :key="index"
          >
            <div class="homestay_apply_center_item">
              <img class="homestay_apply_center_item_img" :src="item.img" />
              <div class="homestay_apply_center_item_text">
                {{ item.title }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 智能管理 -->
    <div class="homestay_apply_manage_bg">
      <div class="homestay_apply_manage_title">智能管理</div>
      <div class="homestay_apply_manage_info">
        3大管理功能 帮助酒店商家提升运营效率
      </div>
      <div class="homestay_apply_manage_center">
        <div class="homestay_apply_manage_center_item">
          <div class="homestay_apply_manage_center_item_top">客房管理</div>
          <div class="homestay_apply_manage_center_item_bottom">
            <div class="homestay_apply_manage_center_item_bottom_text">
              房型设置<br />房态管理<br />价格日历<br />优惠折扣
            </div>
          </div>
        </div>
        <div
          class="homestay_apply_manage_center_item homestay_apply_manage_center_item_center"
        >
          <div class="homestay_apply_manage_center_item_top">订单管理</div>
          <div class="homestay_apply_manage_center_item_bottom">
            <div class="homestay_apply_manage_center_item_bottom_text">
              预订订单<br />修改订单<br />住宿记录<br />商城订单
            </div>
          </div>
        </div>
        <div class="homestay_apply_manage_center_item">
          <div class="homestay_apply_manage_center_item_top">门店管理</div>
          <div class="homestay_apply_manage_center_item_bottom">
            <div class="homestay_apply_manage_center_item_bottom_text">
              收入报表<br />信息设置<br />......
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 客房管理 -->
    <div class="homestay_apply_room_manage_bg">
      <div class="homestay_apply_room_manage_center">
        <div class="homestay_apply_room_manage_left">
          <div class="homestay_apply_room_manage_left_title">客房管理</div>
          <div class="homestay_apply_room_manage_left_info">
            多房型设置满足客户多种需求
          </div>
        </div>
        <div class="homestay_apply_room_manage_right_bg">
          <div class="homestay_apply_room_manage_right">
            <div
              class="homestay_apply_room_manage_right_item homestay_apply_room_manage_right_item_rb"
            >
              <div class="homestay_apply_room_manage_right_item_title">
                房型设置
              </div>
              <div class="homestay_apply_room_manage_right_item_info">
                商家可根据房型大小，设置单人房、标准房、套房等多种房型
              </div>
            </div>
            <div
              class="homestay_apply_room_manage_right_item homestay_apply_room_manage_right_item_rb"
            >
              <div class="homestay_apply_room_manage_right_item_title">
                房号设置
              </div>
              <div class="homestay_apply_room_manage_right_item_info">
                商家设置放号，可控制房态中房号排序，支持查看客房预订单分配房号
              </div>
            </div>
            <div
              class="homestay_apply_room_manage_right_item homestay_apply_room_manage_right_item_b"
            >
              <div class="homestay_apply_room_manage_right_item_title">
                价格设置
              </div>
              <div class="homestay_apply_room_manage_right_item_info">
                商家自定义价格和预设押金
              </div>
            </div>
          </div>
          <div class="homestay_apply_room_manage_right">
            <div
              class="homestay_apply_room_manage_right_item homestay_apply_room_manage_right_item_r"
            >
              <div class="homestay_apply_room_manage_right_item_title">
                付费方式
              </div>
              <div class="homestay_apply_room_manage_right_item_info">
                在线预付/到店支付
              </div>
            </div>
            <div
              class="homestay_apply_room_manage_right_item homestay_apply_room_manage_right_item_r"
            >
              <div class="homestay_apply_room_manage_right_item_title">
                配套服务
              </div>
              <div class="homestay_apply_room_manage_right_item_info">
                免费WIFI/停车场/洗衣服务等
              </div>
            </div>
            <div class="homestay_apply_room_manage_right_item">
              <div class="homestay_apply_room_manage_right_item_title">
                人数限定
              </div>
              <div class="homestay_apply_room_manage_right_item_info">
                根据实际房型设置入住人数
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 房态管理 -->
    <div class="room_state_bg">
      <div class="room_state_title">房态管理</div>
      <div class="room_state_info">
        酒店前台操作办理预定、入住、退房等酒店常规功能。实时同步房间状态，默认显示15天的房间情况，清晰的房态展示与快速操作，进一步提高酒店前台工作效率，同时酒店商家收款和结算支持余额和其他收款方式
      </div>
      <div class="room_state_center_bg">
        <div class="room_state_center">
          <div
            class="room_state_center_item"
            v-for="(item, index) in room_state_top_item"
            :key="index"
          >
            <div class="room_state_center_text_bg">
              <div class="room_state_center_title">{{ item.title }}</div>
              <div class="room_state_center_info">
                {{ item.content }}
              </div>
            </div>
            <img
              class="room_state_center_line"
              src="../../../static/other/ic_room_state_center_line_gray.png"
            />
            <img
              class="room_state_center_circle"
              src="../../../static/other/ic_room_state_center_line_circle.png"
            />
          </div>
        </div>
        <div class="room_state_line" />
        <div class="room_state_center room_state_center_around">
          <div
            class="room_state_center_item"
            v-for="(item, index) in room_state_bottom_item"
            :key="index"
          >
            <img
              class="room_state_center_circle"
              src="../../../static/other/ic_room_state_center_line_circle.png"
            />
            <img
              class="room_state_center_line"
              src="../../../static/other/ic_room_state_center_line_gray.png"
            />
            <div class="room_state_center_text_bg">
              <div class="room_state_center_title">{{ item.title }}</div>
              <div class="room_state_center_info">
                {{ item.content }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 价格日历 -->
    <div class="price_calendar_bg">
      <div class="price_calendar_title">价格日历</div>
      <div class="price_calendar_info">
        可灵活管理每个房型每日价格，多价格调整快速设置
      </div>
      <div class="price_calendar_center">
        <img
          class="price_calendar_center_img"
          src="../../../static/other/ic_price_calendar_center_img.png"
        />
        <div class="price_calendar_center_right">
          <div class="price_calendar_center_right_title">价格显示/调整</div>
          <div class="price_calendar_center_right_info">
            显示当月价格日历，亦可显示其它月份的价格日历，三种重复周期（仅当天、每天、每周）选择，同时根据需求随时变更房价
          </div>
          <div class="price_calendar_center_right_title">入门设置</div>
          <div class="price_calendar_center_right_info">
            不同的房型价格日历不同，每个格子显示日期+价格+房间数量，当天的房价格子用特殊的颜色标识
          </div>
        </div>
      </div>
    </div>
    <!-- 优惠折扣 -->
    <div class="room_discount_bg">
      <div class="room_discount_title">优惠折扣</div>
      <div class="room_discount_info">
        多种优惠折扣组合设置，助力酒店灵活营销
      </div>
      <div class="room_discount_center">
        <img
          class="room_discount_left_img"
          src="../../../static/other/ic_room_discount_left_img.png"
        />
        <img
          class="room_discount_right_img"
          src="../../../static/other/ic_room_discount_right_img.png"
        />
      </div>
    </div>
    <!-- 订单管理 -->
    <div class="room_order_bg">
      <div class="room_order_top">
        <div class="room_order_top_title">订单管理</div>
        <div class="room_order_top_info">方便快捷 提升商家运营效率</div>
      </div>
      <div class="room_order_steps_bg">
        <el-row :gutter="40">
          <el-col
            :span="6"
            v-for="(item, index) in room_order_steps_item"
            :key="index"
          >
            <div class="room_order_steps_item">
              <img class="room_order_steps_item_img" :src="item.img" />
              <div class="room_order_steps_item_text">
                <div class="room_order_steps_item_title">
                  {{ item.title }}
                </div>
                <div class="room_order_steps_item_info">{{ item.content }}</div>
                <div class="room_order_steps_item_info">
                  {{ item.content_two }}
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="room_order_bottom">
        <img
          class="room_order_bottom_left_img"
          src="../../../static/other/ic_room_order_bottom_left_img.png"
        />
        <div class="room_order_bottom_right">
          <div class="room_order_bottom_right_title">预订订单管理</div>
          <div class="room_order_bottom_right_info">
            预订订单管理实时同步房间库存，一键快速预订，支持查看、搜索、筛选以及待确认客房的确认、拒绝与选择房号
          </div>
          <div class="room_order_bottom_right_title">住宿记录管理</div>
          <div class="room_order_bottom_right_info">
            支持住宿记录查看，收集客户住宿信息/偏好，精准营销，支持查看、搜索、筛选
          </div>
          <div class="room_order_bottom_right_title">商城订单管理</div>
          <div class="room_order_bottom_right_info">
            商城订单管理，提升客户消费体验，同时支持商城订单的查看、搜索、筛选
          </div>
          <div class="room_order_bottom_right_title">维权订单</div>
          <div class="room_order_bottom_right_info">
            帮助商家/客户维护自身权益，支持查看、搜索、筛选以及待确认维权订单的确认与拒绝
          </div>
        </div>
      </div>
    </div>
    <!-- 多门店管理 -->
    <div class="room_store_bg">
      <div class="room_store_title">多门店管理</div>
      <div class="room_store_info">商户可根据门店规模，设置门店管理</div>
      <div class="room_store_bottom">
        <el-row :gutter="80">
          <el-col :span="12">
            <div class="room_store_bottom_item">
              <img
                class="room_store_bottom_item_img1"
                src="../../../static/other/ic_room_store_bottom_item_img1.png"
              />
              <div class="room_store_bottom_item_text">
                <span class="blue">总店权限</span>
                可以发布商品、分配商品的适用门店、查看所有门店数据
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="room_store_bottom_item">
              <img
                class="room_store_bottom_item_img2"
                src="../../../static/other/ic_room_store_bottom_item_img2.png"
              />
              <div class="room_store_bottom_item_text">
                <span class="blue">分店权限</span>
                每个门店单独管理房型、房号、房态，其他门店后台互不影响
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="room_store_data_bg">
      <div class="room_store_data_title">多门店管理</div>
      <div class="room_store_data_info">专业数据报表 多维度分析管理数据</div>
      <div class="room_store_data_bottom">
        <div class="room_store_data_left">
          <div class="room_store_data_left_bg room_store_data_left_top">
            <div class="room_store_data_left_item">
              <img
                class="room_store_data_left_item_img"
                src="../../../static/other/ic_room_store_data_left_item_img1.png"
              />
              <div class="room_store_data_left_item_title">业务统计</div>
              <div class="room_store_data_left_item_content">
                门店营收总额、预订数、门店营收趋势、门店页面访问趋势分析
              </div>
            </div>
            <div class="room_store_data_left_item">
              <img
                class="room_store_data_left_item_img"
                src="../../../static/other/ic_room_store_data_left_item_img2.png"
              />
              <div class="room_store_data_left_item_title">营销统计</div>
              <div class="room_store_data_left_item_content">
                优惠券领取量、使用量、使用率、优惠券领取趋势、优惠券使用趋势分析
              </div>
            </div>
          </div>
          <div class="room_store_data_left_bg">
            <div class="room_store_data_left_item">
              <img
                class="room_store_data_left_item_img"
                src="../../../static/other/ic_room_store_data_left_item_img3.png"
              />
              <div class="room_store_data_left_item_title">会员统计</div>
              <div class="room_store_data_left_item_content">
                会员总数、会员可用积分统计、新增会员趋势分析、会员激活数、消费人数、消费人数分析
              </div>
            </div>
            <div class="room_store_data_left_item">
              <img
                class="room_store_data_left_item_img"
                src="../../../static/other/ic_room_store_data_left_item_img4.png"
              />
              <div class="room_store_data_left_item_title">积分统计</div>
              <div class="room_store_data_left_item_content">
                发放积分、消耗积分、积分发放趋势分析、积分发放途径分析
              </div>
            </div>
          </div>
        </div>
        <img
          class="room_store_data_right_img"
          src="../../../static/other/ic_room_store_data_right_img.png"
        />
      </div>
    </div>
    <!-- 丰富的管理应用 -->
    <div class="room_manage_apply_bg">
      <img
        class="room_manage_apply_img"
        src="../../../static/other/bg_room_manage_apply.png"
      />
      <div class="room_manage_apply">
        <div class="room_manage_apply_left">
          <div class="room_manage_apply_left_title">丰富的管理应用</div>
          <div class="room_manage_apply_left_content">
            一站式满足酒店后端管理需求
          </div>
        </div>
        <div class="room_manage_apply_right">
          <div class="room_manage_apply_right_title">
            独立PC+APP+小程序解决方案搭建酒店自己的营销管理平台
          </div>
          <div class="room_manage_apply_right_card">
            <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
              <el-col
                :span="6"
                v-for="(item, index) in room_manage_items"
                :key="index"
              >
                <div class="room_manage_item">
                  <div class="room_manage_item_top">
                    <img
                      style="width: 32px; height: 32px"
                      :class="item.className"
                      :src="item.img"
                    />
                    <div class="room_manage_item_title">{{ item.title }}</div>
                  </div>
                  <div class="room_manage_item_content">{{ item.content }}</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <!-- 多重营销功能组合 -->
    <div class="room_marketing_bg">
      <div class="room_marketing_center">
        <img
          v-if="room_marketing == 1"
          id="room_marketing_left_img"
          class="room_marketing_left_img"
          src="../../../static/other/ic_room_marketing_left_img1.png"
        />
        <img
          v-if="room_marketing == 2"
          class="room_marketing_left_img"
          src="../../../static/other/ic_room_marketing_left_img2.png"
        />
        <div class="room_marketing_right">
          <div class="room_marketing_right_title">多重营销功能组合</div>
          <div class="room_marketing_right_info">
            裂变吸粉、激活用户、提高酒店营销
          </div>
          <el-radio-group v-model="room_marketing">
            <el-radio-button label="1"
              >分享传播 让顾客带来更多的顾客</el-radio-button
            >
            <el-radio-button label="2"
              >互动小游戏 拉近客户间的距离</el-radio-button
            >
          </el-radio-group>
        </div>
      </div>
    </div>
    <!-- 客户管理 -->
    <div class="room_customer_bg">
      <div class="room_customer_center">
        <div class="room_customer_left">
          <div class="room_customer_left_title">客户管理</div>
          <div class="room_customer_left_info">
            裂变吸粉、激活用户、提高酒店营销
          </div>
          <el-radio-group v-model="room_customer">
            <el-radio-button label="1"
              >吸引新客户在互动中成为忠实vip</el-radio-button
            >
            <el-radio-button label="2"
              >会员权益灵活多样 智能惠及客户</el-radio-button
            >
          </el-radio-group>
        </div>
        <div class="room_customer_right">
          <img
            v-if="room_customer == 1"
            id="room_customer_right_img"
            class="room_customer_right_img"
            src="../../../static/other/ic_room_customer_right_img1.png"
          />
          <img
            v-if="room_customer == 2"
            class="room_customer_left_img2"
            src="../../../static/other/ic_room_customer_right_img2.png"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sliders: [
        {
          // img: require("../../../static/slider/a1.png"),
          img: require("../../../static/slider/banner.png"),
        },
      ],
      homestay_apply_item: [
        {
          img: require("../../../static/other/ic_homestay_apply_item_img1.png"),
          title: "连锁酒店",
        },
        {
          img: require("../../../static/other/ic_homestay_apply_item_img2.png"),
          title: "星级酒店",
        },
        {
          img: require("../../../static/other/ic_homestay_apply_item_img3.png"),
          title: "度假酒店",
        },
        {
          img: require("../../../static/other/ic_homestay_apply_item_img4.png"),
          title: "高级民宿",
        },
      ],
      room_order_steps_item: [
        {
          img: require("../../../static/other/ic_room_order_steps_item_img1.png"),
          title: "用户",
          content: "选择入住日期",
          content_two: "点击立即预订",
        },
        {
          img: require("../../../static/other/ic_room_order_steps_item_img2.png"),
          title: "完善预订信息",
          content: "设置人数/姓名/电话",
          content_two: "提交订单",
        },
        {
          img: require("../../../static/other/ic_room_order_steps_item_img3.png"),
          title: "订单",
          content: "确认订单",
          content_two: "在线支付",
        },
        {
          img: require("../../../static/other/ic_room_order_steps_item_img4.png"),
          title: "预订成功",
          content: "",
          content_two: "",
        },
      ],
      room_state_top_item: [
        { title: "空房", content: "办理入住/预订设置留订设置" },
        { title: "在住房", content: "订单详情/换房/退房/收款" },
        { title: "净房", content: "转为脏房/转为维修房" },
        { title: "脏房", content: "转为净房/转为维修房" },
      ],
      room_state_bottom_item: [
        { title: "预订房", content: "订单详情/办理入住/取消预约" },
        { title: "保留房", content: "设置保留时间/取消保留" },
        { title: "维修房", content: "转为脏房/转为净房" },
      ],
      room_manage_items: [
        {
          img: require("../../../static/other/ic_room_manage_item_img1.png"),
          title: "在线订房",
          content: "客户在线查看、预订房间预订房间",
          className: "room_manage_item_img1",
        },
        {
          img: require("../../../static/other/ic_room_manage_item_img2.png"),
          title: "在线商城",
          content: "酒店增值服务线上销售",
          className: "room_manage_item_img2",
        },
        {
          img: require("../../../static/other/ic_room_manage_item_img3.png"),
          title: "智能客服系统",
          content: "实时接受处理信息",
          className: "room_manage_item_img3",
        },
        {
          img: require("../../../static/other/ic_room_manage_item_img4.png"),
          title: "订单管理",
          content: "客户在线查看、预订房间预订房间",
          className: "room_manage_item_img4",
        },
        {
          img: require("../../../static/other/ic_room_manage_item_img5.png"),
          title: "入/退房管理",
          content: "快速办理客户入住及退房",
          className: "room_manage_item_img5",
        },
        {
          img: require("../../../static/other/ic_room_manage_item_img6.png"),
          title: "房间日历",
          content: "支持根据不同时间制定房价",
          className: "room_manage_item_img6",
        },
        {
          img: require("../../../static/other/ic_room_manage_item_img7.png"),
          title: "房态标记",
          content: "快速查看、修改房间状态",
          className: "room_manage_item_img7",
        },
        {
          img: require("../../../static/other/ic_room_manage_item_img8.png"),
          title: "客房分配",
          content: "帮助前台进行客房及时分配",
          className: "room_manage_item_img8",
        },
        {
          img: require("../../../static/other/ic_room_manage_item_img9.png"),
          title: "多门店管理",
          content: "连锁型酒店全门店统一管理",
          className: "room_manage_item_img9",
        },
        {
          img: require("../../../static/other/ic_room_manage_item_img10.png"),
          title: "数据管理",
          content: "经营数据记录及深入分析",
          className: "room_manage_item_img10",
        },
      ],
      room_marketing: "1",
      room_customer: "1",
    };
  },

  computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        return "500px";
      } else {
        return "250px";
      }
    },
  },

  mounted() {},

  methods: {
    room_marketing_change() {
      // document.getElementById("room_marketing_left_img").setAttribute("content",require(""));
      // document.getElementById("room_marketing_left_img").setAttribute("content","../../../static/other/ic_room_marketing_left_img2.png");
      // document.getElementById("room_marketing_left_img").src="../../../static/other/ic_room_marketing_left_img2.png";
      // document.getElementById("room_marketing_left_img").content=url("../../../static/other/ic_room_marketing_left_img1.png");
      // room_marketing;
    },
  },
};
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 100%;
}
// 适用商家
.homestay_apply_bg {
  width: 100%;
  height: 500px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .homestay_apply_title {
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    line-height: 39px;
    color: #333333;
    margin-top: 80px;
    margin-bottom: 60px;
  }
  .homestay_apply_center {
    width: 1180px;
    .homestay_apply_center_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      .homestay_apply_center_item_img {
        width: 265px;
        height: 176px;
      }
      .homestay_apply_center_item_text {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 18px;
        line-height: 25px;
        color: #333333;
        margin-top: 24px;
      }
    }
  }
}
// 智能管理
.homestay_apply_manage_bg {
  width: 100%;
  height: 590px;
  background: #f3f5fa;
  display: flex;
  flex-direction: column;
  align-items: center;

  .homestay_apply_manage_title {
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    line-height: 39px;
    color: #333333;
    margin-top: 80px;
    margin-bottom: 8px;
  }
  .homestay_apply_manage_info {
    font-family: "PingFang SC";
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #666666;
  }
  .homestay_apply_manage_center {
    display: flex;
    flex-direction: row;
    margin-top: 60px;

    .homestay_apply_manage_center_item {
      display: flex;
      flex-direction: column;
      align-items: center;

      .homestay_apply_manage_center_item_top {
        font-family: "PingFang SC";
        font-weight: 500;
        font-size: 18px;
        line-height: 66px;
        text-align: center;
        color: #ffffff;
        width: 186px;
        height: 66px;
        background: #3370ff;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 8px;
      }
      .homestay_apply_manage_center_item_bottom {
        width: 252px;
        height: 252px;
        background: rgba(51, 112, 255, 0.14);
        border: 1px solid rgba(255, 255, 255, 0.5);
        backdrop-filter: blur(12px);
        border-radius: 8px;
        position: relative;
        top: -15px;
        left: 0;
        display: flex;
        justify-content: center;
        .homestay_apply_manage_center_item_bottom_text {
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 16px;
          line-height: 32px;
          color: #333333;
          margin-top: 60px;
          text-align: center;
        }
      }
    }
    .homestay_apply_manage_center_item_center {
      margin-left: 132px;
      margin-right: 132px;
    }
  }
}
// 客房管理
.homestay_apply_room_manage_bg {
  width: 100%;
  height: 600px;
  background: #ffffff;
  display: flex;
  justify-content: center;
  .homestay_apply_room_manage_center {
    display: flex;
    flex-direction: row;
    margin-top: 80px;

    .homestay_apply_room_manage_left {
      background: url("../../../static/other/bg_homestay_apply_room_manage_left.png");
      width: 295px;
      height: 440px;
      display: flex;
      flex-direction: column;
      .homestay_apply_room_manage_left_title {
        font-family: "PingFang SC";
        font-weight: 500;
        font-size: 28px;
        line-height: 39px;
        text-align: center;
        color: #ffffff;
        margin-top: 200px;
        margin-bottom: 8px;
      }
      .homestay_apply_room_manage_left_info {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: #ffffff;
      }
    }

    .homestay_apply_room_manage_right_bg {
      display: flex;
      flex-direction: column;
      width: 885px;

      .homestay_apply_room_manage_right {
        display: flex;
        flex-direction: row;

        .homestay_apply_room_manage_right_item {
          width: 295px;
          height: 220px;
          background: #fafbfe;
          display: flex;
          flex-direction: column;

          .homestay_apply_room_manage_right_item_title {
            font-family: "PingFang SC";
            font-weight: 500;
            font-size: 18px;
            line-height: 25px;
            color: #333333;
            margin-top: 36px;
            margin-left: 32px;
            margin-bottom: 16px;
          }
          .homestay_apply_room_manage_right_item_info {
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #666666;
            margin-left: 32px;
            margin-right: 32px;
          }
        }

        .homestay_apply_room_manage_right_item_rb {
          border-right: 1px solid #e5e7eb;
          border-bottom: 1px solid #e5e7eb;
        }

        .homestay_apply_room_manage_right_item_r {
          border-right: 1px solid #e5e7eb;
        }
        .homestay_apply_room_manage_right_item_b {
          border-bottom: 1px solid #e5e7eb;
        }
      }
    }
  }
}
// 房态管理
.room_state_bg {
  width: 100%;
  height: 630px;
  background: #f3f5fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  .room_state_title {
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    line-height: 39px;
    color: #333333;
    margin-top: 80px;
    margin-bottom: 8px;
  }
  .room_state_info {
    font-family: "PingFang SC";
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #666666;
    text-align: center;
    width: 830px;
    margin-bottom: 80px;
  }
  .room_state_center_bg {
    width: 1180px;
    display: flex;
    flex-direction: column;

    .room_state_center {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      z-index: 10;
      .room_state_center_item {
        display: flex;
        flex-direction: column;
        align-items: center;
        .room_state_center_text_bg {
          background: #ffffff;
          border-radius: 4px;
          width: 168px;
          height: 107px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .room_state_center_title {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 500;
            font-size: 18px;
            line-height: 25px;
            color: #666666;
            margin-top: 16px;
            margin-bottom: 8px;
          }
          .room_state_center_info {
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 14px;
            line-height: 21px;
            color: #666666;
            text-align: left;
            width: 144px;
          }
        }
        .room_state_center_line {
          height: 32px;
        }
        .room_state_center_circle {
          height: 18px;
          width: 18px;
        }
      }
      .room_state_center_item:hover {
        .room_state_center_text_bg {
          background: #3370ff;
        }
        .room_state_center_title {
          color: #ffffff;
        }
        .room_state_center_info {
          color: #ffffff;
        }
        .room_state_center_line {
          content: url("../../../static/other/ic_room_state_center_line_blue.png");
        }
        .room_state_center_circle {
          content: url("../../../static/other/ic_room_state_center_line_circle_s.png");
        }
      }
    }
    .room_state_line {
      width: 1180px;
      height: 4px;
      background: #eaeaea;
      position: relative;
      top: -11px;
      margin: 0 auto;
    }
    .room_state_center_around {
      justify-content: space-around;
      position: relative;
      top: -22px;
      margin-left: 78px;
      margin-right: 78px;
    }
  }
}
// 价格日历
.price_calendar_bg {
  width: 100%;
  height: 600px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .price_calendar_title {
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    line-height: 39px;
    color: #333333;
    margin-top: 80px;
    margin-bottom: 8px;
  }
  .price_calendar_info {
    font-family: "PingFang SC";
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #666666;
  }
  .price_calendar_center {
    display: flex;
    flex-direction: row;
    width: 1180px;
    margin-top: 80px;
    .price_calendar_center_img {
      width: 420px;
      height: 272px;
    }
    .price_calendar_center_right {
      display: flex;
      flex-direction: column;
      margin-left: 180px;
      margin-top: 10px;

      .price_calendar_center_right_title {
        font-family: "PingFang SC";
        font-weight: 500;
        font-size: 18px;
        line-height: 25px;
        color: #333333;
        margin-top: 32px;
        margin-bottom: 12px;
      }
      .price_calendar_center_right_info {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #666666;
        width: 580px;
      }
    }
  }
}
// 优惠折扣
.room_discount_bg {
  width: 100%;
  height: 640px;
  background: #f3f5fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  .room_discount_title {
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    line-height: 39px;
    color: #333333;
    margin-top: 80px;
    margin-bottom: 8px;
  }
  .room_discount_info {
    font-family: "PingFang SC";
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #666666;
    margin-bottom: 80px;
  }
  .room_discount_center {
    display: flex;
    flex-direction: row;
    width: 1180px;
    .room_discount_left_img {
      width: 472px;
      height: 330px;
      margin-right: 250px;
    }
    .room_discount_right_img {
      width: 502px;
      height: 334pxs;
      margin-top: 25px;
    }
  }
}
// 订单管理
.room_order_bg {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #ffffff;

  .room_order_top {
    width: 100%;
    height: 288px;
    background: url("../../../static/other/bg_room_order_top.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    .room_order_top_title {
      font-family: "PingFang SC";
      font-weight: 500;
      font-size: 28px;
      line-height: 39px;
      text-align: center;
      color: #333333;
      margin-top: 80px;
      margin-bottom: 8px;
    }
    .room_order_top_info {
      font-family: "PingFang SC";
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      text-align: center;
      color: #666666;
    }
  }

  .room_order_steps_bg {
    width: auto;
    height: 116px;
    position: relative;
    top: -58px;
    margin: 0 auto;
    .room_order_steps_item {
      border-radius: 8px;
      border: 1px solid #ebeef5;
      background: #ffffff;
      width: 265px;
      height: 116px;
      display: flex;
      flex-direction: row;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      .room_order_steps_item_img {
        width: 48px;
        height: 48px;
        margin-left: 24px;
        margin-top: 33px;
        margin-right: 20px;
      }
      .room_order_steps_item_text {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        .room_order_steps_item_title {
          font-family: "PingFang SC";
          font-weight: 500;
          font-size: 18px;
          line-height: 25px;
          color: #333333;
          margin-bottom: 4px;
        }
        .room_order_steps_item_info {
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #666666;
          margin-bottom: 4px;
        }
      }
    }
  }
  .room_order_bottom {
    width: 1180px;
    height: auto;
    margin-top: 30px;
    margin-bottom: 80px;
    display: flex;
    flex-direction: row;
    .room_order_bottom_left_img {
      width: 518px;
      height: 444px;
    }
    .room_order_bottom_right {
      margin-left: 240px;
      display: flex;
      flex-direction: column;
      .room_order_bottom_right_title {
        font-family: "PingFang SC";
        font-weight: 500;
        font-size: 18px;
        line-height: 25px;
        color: #333333;
        margin-bottom: 8px;
      }
      .room_order_bottom_right_info {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #666666;
        margin-bottom: 36px;
        width: 410px;
      }
    }
  }
}
// 多门店管理
.room_store_bg {
  width: 100%;
  height: 888px;
  background: #f3f5fa;
  display: flex;
  flex-direction: column;
  align-items: center;

  .room_store_title {
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    line-height: 39px;
    color: #333333;
    margin-top: 80px;
    margin-bottom: 8px;
  }
  .room_store_info {
    font-family: "PingFang SC";
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #666666;
    margin-bottom: 70px;
  }

  .room_store_bottom {
    display: flex;
    flex-direction: row;
    width: 1180px;
    .room_store_bottom_item {
      background: #ffffff;
      border-radius: 4px;
      width: 550px;
      height: 590px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;

      .room_store_bottom_item_img1 {
        width: 488px;
        margin-top: 48px;
      }
      .room_store_bottom_item_img2 {
        width: 418px;
        margin-top: 48px;
      }
      .room_store_bottom_item_text {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 13px;
        color: #333333;
        margin-bottom: 31px;
      }
      .blue {
        font-size: 14px;
        font-weight: 500;
        color: #3370ff;
      }
    }
  }
}

.room_store_data_bg {
  width: 100%;
  height: 880px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;

  .room_store_data_title {
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    line-height: 39px;
    color: #333333;
    margin-top: 80px;
    margin-bottom: 8px;
  }
  .room_store_data_info {
    font-family: "PingFang SC";
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #666666;
    margin-bottom: 60px;
  }
  .room_store_data_bottom {
    width: 1180px;
    display: flex;
    flex-direction: row;
    .room_store_data_left {
      display: flex;
      flex-direction: row;
      .room_store_data_left_bg {
        display: flex;
        flex-direction: column;
        margin-left: 32px;
        .room_store_data_left_item {
          border-radius: 8px;
          border: 1px solid #ebeef5;
          background: #ffffff;
          width: 200px;
          height: 260px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 32px;

          .room_store_data_left_item_img {
            width: 46px;
            margin-top: 36px;
            margin-bottom: 24px;
          }
          .room_store_data_left_item_title {
            font-family: "PingFang SC";
            font-weight: 500;
            font-size: 18px;
            line-height: 25px;
            color: #000000;
            margin-bottom: 12px;
          }
          .room_store_data_left_item_content {
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 14px;
            line-height: 21px;
            text-align: center;
            color: #666666;
            margin-left: 20px;
            margin-right: 20px;
          }
        }
      }
      .room_store_data_left_top {
        margin-top: 32px;
      }
    }
    .room_store_data_right_img {
      width: 520px;
      height: 310px;
      margin-left: 196px;
      margin-top: 137px;
    }
  }
}

// 管理应用
.room_manage_apply_bg {
  width: 100%;
  height: 626px;
  display: flex;
  align-items: center;
  justify-content: center;

  .room_manage_apply_img {
    width: 100%;
    height: 626px;
    object-fit: cover;
  }

  .room_manage_apply {
    width: 1180px;
    height: 626px;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: absolute;
    z-index: 10;

    .room_manage_apply_left {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 185px;

      .room_manage_apply_left_title {
        font-family: "PingFang SC";
        font-weight: 500;
        font-size: 28px;
        line-height: 39px;
        color: #333333;
      }
      .room_manage_apply_left_content {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #666666;
        width: 208px;
      }
    }
    .room_manage_apply_right {
      display: flex;
      flex-direction: column;

      .room_manage_apply_right_title {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 20px;
        line-height: 28px;
        color: #ffffff;
        margin-bottom: 32px;
      }

      .room_manage_item {
        border: 1px solid rgba(255, 255, 255, 0.5);
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        width: 182px;
        height: 122px;
        margin-bottom: 20px;
        .room_manage_item_top {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-bottom: 8px;
          margin-top: 20px;
          margin-left: 18px;
        }
        .room_manage_item_img {
          width: 32px;
          height: 32px;
        }
        .room_manage_item_title {
          font-family: "PingFang SC";
          font-weight: 500;
          font-size: 18px;
          line-height: 25px;
          color: #ffffff;
          margin-left: 4px;
        }
        .room_manage_item_content {
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 14px;
          line-height: 21px;
          color: rgba(255, 255, 255, 0.8);
          width: 142px;
          margin-left: 18px;
        }
      }
      .room_manage_item:hover {
        background: #ffffff;
        border-radius: 4px;
        .room_manage_item_title {
          color: #3370ff;
        }
        .room_manage_item_content {
          color: rgba(51, 112, 255, 0.8);
        }
        .room_manage_item_img1 {
          content: url("../../../static/other/ic_room_manage_item_s_img1.png");
        }
        .room_manage_item_img2 {
          content: url("../../../static/other/ic_room_manage_item_s_img2.png");
        }
        .room_manage_item_img3 {
          content: url("../../../static/other/ic_room_manage_item_s_img3.png");
        }
        .room_manage_item_img4 {
          content: url("../../../static/other/ic_room_manage_item_s_img4.png");
        }
        .room_manage_item_img5 {
          content: url("../../../static/other/ic_room_manage_item_s_img5.png");
        }
        .room_manage_item_img6 {
          content: url("../../../static/other/ic_room_manage_item_s_img6.png");
        }
        .room_manage_item_img7 {
          content: url("../../../static/other/ic_room_manage_item_s_img7.png");
        }
        .room_manage_item_img8 {
          content: url("../../../static/other/ic_room_manage_item_s_img8.png");
        }
        .room_manage_item_img9 {
          content: url("../../../static/other/ic_room_manage_item_s_img9.png");
        }
        .room_manage_item_img10 {
          content: url("../../../static/other/ic_room_manage_item_s_img10.png");
        }
      }
    }
  }
}
.room_marketing_bg {
  width: 100%;
  height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;

  .room_marketing_center {
    width: 1180px;
    display: flex;
    flex-direction: row;
    .room_marketing_left_img {
      width: 444px;
      height: 444px;
    }
    .room_marketing_right {
      display: flex;
      flex-direction: column;
      height: 100%;
      margin-left: 280px;
      .room_marketing_right_title {
        font-family: "PingFang SC";
        font-weight: 500;
        font-size: 28px;
        line-height: 39px;
        color: #333333;
        margin-top: 80px;
        margin-bottom: 8px;
      }
      .room_marketing_right_info {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #666666;
        margin-bottom: 32px;
      }
      >>> .el-radio-button {
        margin-bottom: 24px;

        .el-radio-button__inner {
          //修改按钮样式
          width: 428px;
          height: 80px;
          font-size: 18px;
          padding-left: 30px;
          color: #666666;
          text-align: left;
          line-height: 50px;
          background: #e7edfa;
          border-radius: 6px;
        }
        .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          // 修改按钮激活样式
          width: 428px;
          height: 80px;
          font-size: 18px;
          padding-left: 30px;
          color: #333333;
          border: 1px solid #ebeef5;
          background: #ffffff;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          border-left: 6px solid #3370ff;
        }
      }
    }
  }
}

.room_customer_bg {
  width: 100%;
  height: 600px;
  display: flex;
  justify-content: center;
  background: #f3f5fa;

  .room_customer_center {
    width: 1180px;
    height: 600px;
    display: flex;
    flex-direction: row;
    .room_customer_left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-right: 200px;
      .room_customer_left_title {
        font-family: "PingFang SC";
        font-weight: 500;
        font-size: 28px;
        line-height: 39px;
        color: #333333;
        margin-bottom: 8px;
      }
      .room_customer_left_info {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #666666;
        margin-bottom: 32px;
      }
      >>> .el-radio-button {
        margin-bottom: 24px;

        .el-radio-button__inner {
          //修改按钮样式
          width: 428px;
          height: 80px;
          font-size: 18px;
          padding-left: 30px;
          color: #666666;
          text-align: left;
          line-height: 50px;
          background: #e7edfa;
          border-radius: 6px;
        }
        .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          // 修改按钮激活样式
          width: 428px;
          height: 80px;
          font-size: 18px;
          padding-left: 30px;
          color: #333333;
          border: 1px solid #ebeef5;
          background: #ffffff;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          border-left: 6px solid #3370ff;
        }
      }
    }

    .room_customer_right {
      display: flex;
      align-items: center;

      .room_customer_right_img {
        width: 536px;
        height: 360px;
      }
      .room_customer_right_img2 {
        width: 440px;
        height: 440px;
      }
    }
  }
}
</style>
